export default __webpack_public_path__ + "static/media/biorad_logo.ff18f5f6.svg";